import { html, css, LitElement } from 'lit';

export class IxSimpleTooltip extends LitElement {
  static styles = css`
    :host {
      background: var(
        --ix-simple-tooltip-background-color,
        var(--md-sys-color-on-primary-container, #000)
      );
      border-radius: var(--ix-simple-tooltip-border-radius, 5px);
      color: var(
        --ix-simple-tooltip-text-color,
        var(--md-sys-color-on-primary, #fff)
      );
      padding: var(--ix-simple-tooltip-padding, 0.3rem 0.5rem);
    }
  `;

  render() {
    return html` <slot></slot>`;
  }
}

window.customElements.define('ix-simple-tooltip', IxSimpleTooltip);
